import { useMutation } from "@tanstack/react-query";
import { AxiosResponseAndError } from "../types/axiosResponseType";
import axios from "axios";
import { requestURLs } from "../../Environment";

export const useCreateThredMutaion = () => {
  return useMutation<
    AxiosResponseAndError<any>["response"],
    AxiosResponseAndError<any>["error"]
  >({
    mutationFn: () =>
      axios.post(requestURLs.getThread, {}),
  });
};
